function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useRef, useState } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { useGetTrigger } from '../../../hooks/popper';
import { BaseTree } from '../../tree/BaseTree';
import { SearchInput } from './SearchInput';
export function TreePopper(props) {
  var _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      searchPlaceholder = props.searchPlaceholder,
      multiple = props.multiple,
      showLine = props.showLine,
      triggerId = props.triggerId,
      renderItem = props.renderItem,
      cascader = props.cascader,
      disabled = props.disabled,
      show = props.show,
      autoFocusSearch = props.autoFocusSearch,
      filterTreeNode = props.filterTreeNode,
      autoClearSearchValue = props.autoClearSearchValue;
  var inputRef = useRef(null);
  useEffect(function () {
    if (autoFocusSearch && show && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) {
      inputRef.current.focus();
    }
  }, [autoFocusSearch, show]);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  useEffect(function () {
    if (autoClearSearchValue && !show) {
      setSearch('');
    }
  }, [autoClearSearchValue, show]);
  var activeTrigger = useGetTrigger(triggerId);
  var popperWidth = activeTrigger.getRect().width;
  var treeCls = usePrefixCls('tree-popper');
  return React.createElement("div", {
    className: treeCls,
    style: {
      minWidth: popperWidth
    }
  }, searchable && React.createElement(SearchInput, {
    searchPlaceholder: searchPlaceholder,
    search: search,
    onValueChange: setSearch,
    inputRef: inputRef
  }), React.createElement(BaseTree, {
    search: search,
    filterTreeNode: filterTreeNode,
    cascader: cascader,
    renderItem: renderItem,
    multiple: multiple,
    showLine: showLine,
    disabled: disabled
  }));
}